export default __webpack_public_path__ + "static/media/coach.a8430d73.png";